import React from 'react'
import ReactDOM from 'react-dom'
import RootComponent from './App'

ReactDOM.render(<RootComponent />, document.getElementById('root'))
